import React from "react";
import { NavLink } from "react-router-dom";
import { BUSINESS } from "../../config/business";
import { PRODUCTS } from "../../config/products";

const NAV_LABELS = {
  financial_profile_development: "Financial Profile Development",
  personal_capital_strategy: "Personal Capital Strategy",
  business_capital_strategy: "Business Capital Strategy",
  profile_positioning_services: "Account History Positioning",
  grant_readiness_and_funding_research: "Grant Readiness & Research",
  business_foundation_and_entity_setup: "Business Foundation Setup",
};

const GROUPS = [
  {
    items: [
      { to: "/", label: "Overview", testid: "nav-overview", end: true },
      { to: "/leads", label: "Lead Pipeline", testid: "nav-leads" },
      { to: "/clients", label: "Client Portfolio", testid: "nav-clients" },
    ],
  },
  {
    title: "Services",
    testid: "nav-section-services",
    items: PRODUCTS.map((p) => ({ to: p.route, label: NAV_LABELS[p.key], testid: `nav-${p.key.replace(/_/g, "-")}` })),
  },
  {
    title: "Operations",
    testid: "nav-section-operations",
    items: [
      { to: "/documents", label: "Document Queue", testid: "nav-documents" },
      { to: "/referrals", label: "Referral Leaderboard", testid: "nav-referrals" },
      { to: "/revenue", label: "Revenue", testid: "nav-revenue" },
      { to: "/billing", label: "Billing & Invoices", testid: "nav-billing" },
      { to: "/payments", label: "JC3 Payments", testid: "nav-payments" },
      { to: "/events", label: "Event Stream", testid: "nav-events" },
    ],
  },
];

const linkCls = ({ isActive }) =>
  `block pl-[22px] pr-4 py-2.5 text-[15px] border-l-2 transition-colors ${
    isActive ? "bj-nav-active" : "border-transparent text-[#BDB6A6] hover:text-[#F2EBDD]"
  }`;

const Sidebar = ({ open, onNavigate }) => (
  <>
    {open && (
      <div
        data-testid="sidebar-backdrop"
        onClick={onNavigate}
        className="fixed inset-0 top-16 z-20 bg-[#0E1C15]/60 min-[960px]:hidden"
      />
    )}
    <aside
      data-testid="sidebar-nav"
      className={`${open ? "flex" : "hidden"} min-[960px]:flex fixed min-[960px]:sticky top-16 left-0 z-30 h-[calc(100vh-4rem)] w-[264px] shrink-0 bg-[#14281E] flex-col overflow-y-auto`}
    >
      <nav className="flex-1 py-6">
        {GROUPS.map((g, gi) => (
          <div key={gi} className={gi ? "mt-6" : ""}>
            {g.title && (
              <div data-testid={g.testid} className="px-6 mb-2 text-[12px] tracking-[.14em] uppercase text-[#BDB6A6]">
                {g.title}
              </div>
            )}
            {g.items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid} onClick={onNavigate} className={linkCls}>
                {it.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div data-testid="sidebar-motto" className="px-6 py-6 text-[12px] leading-relaxed text-[#BDB6A6]">
        {BUSINESS.tagline}
      </div>
    </aside>
  </>
);

export default Sidebar;
